// src/pages/Invoices.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { Quotes } from '../services/api';
import { useAuth, ROLES } from '../context/AuthContext';

export default function Invoices() {
  const { user }  = useAuth();
  const [list, setList] = useState([]);
  const [busy, setBusy] = useState(true);

  const load = useCallback(() => {
    setBusy(true);
    Quotes.invoices().then(setList).catch(console.error).finally(() => setBusy(false));
  }, []);
  useEffect(load, [load]);

  const approve = async (id, who) => {
    try { await Quotes.approve(id, who); load(); }
    catch (ex) { alert(ex.message); }
  };

  if (busy) return <div className="spinner-wrap"><div className="spinner" /></div>;

  return (
    <div className="page">
      <div className="page-header"><div className="page-title">🧾 Invoice Approvals</div></div>
      {list.length === 0 ? <div className="empty">No pending invoices</div> :
        list.map(inv => (
          <div key={inv.id} className="list-row" style={{ marginBottom:'.5rem' }}>
            <div className="row-main">
              <div className="row-title">#{inv.id} · {inv.name}</div>
              <div className="row-sub">Customer {inv.customer} · Rep: {inv.user_id} · {inv.date_entered?.slice(0,10)}</div>
            </div>
            <div className="row-actions">
              {!inv.ac_id && [ROLES.ADMIN, ROLES.MANAGER].includes(user.ryts) ? (
                <button className="btn btn-sm btn-primary" onClick={() => approve(inv.id, 'inv')}>✓ Manager Approve</button>
              ) : inv.ac_id ? (
                <span className="text-green" style={{ fontSize:'.8rem' }}>✓ Manager: {inv.ac_dt}</span>
              ) : (
                <span className="text-yellow" style={{ fontSize:'.8rem' }}>Pending Manager</span>
              )}
              {inv.ac_id && !inv.fin_id && [ROLES.ADMIN, ROLES.FINANCE].includes(user.ryts) ? (
                <button className="btn btn-sm btn-success" onClick={() => approve(inv.id, 'inv_fin')}>✓ Finance Approve</button>
              ) : inv.fin_id ? (
                <span className="text-green" style={{ fontSize:'.8rem' }}>✓ Finance: {inv.fin_date}</span>
              ) : inv.ac_id ? (
                <span className="text-yellow" style={{ fontSize:'.8rem' }}>Pending Finance</span>
              ) : null}
            </div>
          </div>
        ))
      }
    </div>
  );
}
